<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="page_5"></a>CONTENTS</h1>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="toc"><a href="#/xhtml/05introduction#int">Introduction</a> <a href="#/xhtml/05introduction#int">7</a></p>
<p class="toc"><a href="#/xhtml/06part01#ch1">Chapter 1: BIRTHDAYS</a> <a href="#/xhtml/06part01#ch1">9</a></p>
<p class="toc"><a href="#/xhtml/19part02#ch2">Chapter 2: THE ZODIAC</a> <a href="#/xhtml/19part02#ch2">137</a></p>
<p class="toc"><a href="#/xhtml/46part03#ch3">Chapter 3: NAMES</a> <a href="#/xhtml/46part03#ch3">179</a></p>
<p class="toc"><a href="#/xhtml/53part04#ch4">Chapter 4: DREAMS</a> <a href="#/xhtml/53part04#ch4">223</a></p>
<p class="toc"><a href="#/xhtml/79part05#ch5">Chapter 5: COLOR</a> <a href="#/xhtml/79part05#ch5">291</a></p>
<p class="toc"><a href="#/xhtml/89part06#ch6">Chapter 6: LOVE AND FRIENDSHIP</a> <a href="#/xhtml/89part06#ch6">337</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-contents.vue?7f5f5d50